export default {
  title_points: 'Purchase points',
  title_daypass: 'Purchase daypass',
  title_signature: 'Sign documents',
  message: {
    complete_main: 'Process complete. You can close this window.',
    error: 'An error ocurred. Please contact an administrator if it persists.'
  },
  form: {
    name: 'Name',
    surname: 'Surname',
    guest: 'Account owner',
    transaction_guest: 'Purchase by',
    current_balance: 'Current balance',
    final_balance: 'Final balance',
    amount: 'Purchase',
    price: 'Price',
    price_conversion: 'Price conversion',
    payment_currency: 'Payment currency',
    numberGuests: 'Number of guests',
    facility: 'Facility',
    conversion: 'Price conversion',
    currency: 'Currency',
    paymentMethod: 'Payment method',
    paymentMethodAction: 'Select payment method',
    payment_method: 'Payment method',
    observations: 'Observations'
  },
  transaction_types: {
    payment: 'Pay now',
    booking: 'Room charge'
  },
  actions: {
    purchase_points: 'Purchase {amount} {currency}',
    purchase: 'Purchase',
    reset: 'Reset',
    submit: 'Submit'
  },
  warnings: {
    no_exchange_rate: 'There is no configured exchange rate for this currency'
  },
  points: {
    discount: 'This guest has a {discount}% discount',
    disabled_account: 'Inactive account',
    no_station: 'Configure a station on the management panel to proceed',
    no_base_currency_allowed: `The configured station is not allowed to use the facility's currency`,
    no_points_currency_allowed: `The configured station is not allowed to use the points currency`
  },
  signature: {
    terms_title: 'Use of wristband approval',
    terms_body: `
      The wristbands are used as guest identifiers around the hotel and to open the room assigned for the stay. I authorize the persons listed below traveling with me, to use the wristbands to make additional charges to the room, and to use the Joe Merchant's Points assigned to the same room. The assigned wristband serial number may change if it’s necessary to change or replace the wristband during the stay. The replacement of the wristband has an extra charge if misplaced or lost. Wristbands will be deactivated upon check out.<br/><br/>
      I am aware that Joe Merchant´s Points can only be used for purchases at Joe Merchant´s, that the allocation of Joe Merchant´s Points is made in a single deposit per room, according to the room category and number of reserved nights, and that adult guests assigned to the same room share the points. Only the minors authorized by the room holder can activate the wristbands to use the Joe Merchant's Points. Joe Merchant´s Points are not interchangeable for money, are not transferable, expire at the time of Check out, and are not refundable. Joe Merchant´s Points are not cumulative from previous stays. In case the guest requests an upgrade, the Joe Merchant´s Points will be updated according to the type of room. When the upgrade is effective, the deposit is completed in accordance with the Joe Merchant´s extra points that apply from that day. No retroactive assets will be assigned. The guest can buy additional point packages at Joe Merchant´s or at front desk. If Joe Merchant´s Points are insufficient to make a purchase, the difference is charged to the room, or it will be covered by other authorized methods. The delivery of items purchased at Joe Merchant´s to the room has an extra charge that can be paid with points or other authorized payment methods. Consumption of products purchased at Joe Merchant’s in the hotel's restaurants and bars is prohibited. The only product purchased at Joe Merchant’s accepted at restaurants and bars are closed wine bottles. Joe Merchant´s Points cannot be used as tips, for spa purchases, etc., they are exclusive to Joe Merchant´s.
    `,
    guests_list: 'Guests enabled to use the wristband:',
    guest_selected: 'Select the guest who signs this document:',
    sign_acceptance: 'I accept the terms and conditions defined in this document',
    selec_lang: 'Choose the language',
    langs: [
      {
        name: 'Spanish',
        code: 'es'
      },
      {
        name: 'English',
        code: 'en'
      }
    ],
    room: 'Room {name}',
    no_room: 'No room'
  }
}
